module.exports = __webpack_public_path__ + "img/daniel-abugattas.17b5de25.png";